import './index.less';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PieChartComponent from './pie-chart';
import { ReactComponent as BottomDecSvg } from './icons/bottom-decoration.svg';
import { ReactComponent as SlashSvg } from './icons/slash.svg';
import { dbox } from '@/declare/interface/dbox';
import { queryDboxs, querySensors } from '@/declare/api/monix';
import { sensor } from '@/declare/interface/sensor';
import axios from 'axios';
interface IProps {

}
/**
 * 采集器状态枚举
 */
export const DboxStatusTypesEnum = {
    OFFLINE: 0,
    ONLINE: 1,
}

/**
 * 传感器状态枚举
 */
export const SensorStatusTypesEnum = {
    OFFLINE: 0,
    ONLINE: 1,
    ABNORMAL: 2,
}

export default function DevicePanel(props: IProps) {
    let { monixProjectId } = useParams();
    const [dboxs, setDboxs] = useState<dbox[]>([]);
    const [sensors, setSensors] = useState<sensor[]>([]);

    useEffect(() => {
        let projectId = monixProjectId;
        // 请求设备：采集箱和传感器数据
        let queryDboxsPromise = queryDboxs({
            project_id: projectId,
        });
        let querySensorsPromise = querySensors({
            project_id: projectId,
        })
        // 设备
        axios.all([queryDboxsPromise, querySensorsPromise]).then(res => {
            let dboxs = res[0].data;
            let sensors = res[1].data;
            setSensors(sensors);
            setDboxs(dboxs);
        })
    }, [])

    return (
        <div className='device-panel'>
            <div className="device-title">
                <span>设备</span>
            </div>
            <div className="device-pie">
                <div className="device-pie-text">
                    <PieChartComponent current={dboxs.filter(item => item.work_status === DboxStatusTypesEnum.ONLINE)?.length || 0} total={dboxs?.length || 0} />
                    <div className="device-text-number">
                        {dboxs.filter(item => item.work_status === DboxStatusTypesEnum.ONLINE)?.length || 0}
                        <SlashSvg style={{ height: '20px', width: 'auto', marginLeft: '4px', marginRight: '1px', flexShrink: 0 }} />
                        {dboxs?.length || 0}
                    </div>
                    <div className="device-text-other" >
                        <BottomDecSvg style={{ marginBottom: '10px' }} />
                        <div className="device-text-name" >采集箱</div>
                    </div>
                </div>
                <div className="device-pie-text">
                    <PieChartComponent current={sensors.filter(item => item.work_status === SensorStatusTypesEnum.ONLINE)?.length || 0} total={sensors?.length || 0} />

                    <div className="device-text-number">
                        {sensors.filter(item => item.work_status === SensorStatusTypesEnum.ONLINE)?.length || 0}
                        <SlashSvg style={{ height: '20px', width: 'auto', marginLeft: '4px', marginRight: '1px', flexShrink: 0 }} />
                        {sensors?.length || 0}
                    </div>
                    <div className="device-text-other">
                        <BottomDecSvg style={{ marginBottom: '10px' }} />
                        <div className="device-text-name">传感器</div>
                    </div>
                </div>
            </div>
        </div>
    )
}